/**
 * B9 (fixronde 12-10-2026): het notitiestempel "[Naam dd.mm.jj uu.mm] " dat
 * bij de eerste focus in een notitieveld verschijnt, zodat te zien is wie
 * wat wanneer schreef. Staat er al tekst, dan komt het stempel op een nieuwe
 * regel onderaan. WP3b: vierkante haken en geen streepje meer, zodat
 * overzichten het stempel kunnen verbergen (verbergNotitiestempels).
 */
const twee = (n: number) => String(n).padStart(2, "0");

export function maakStempel(naam: string, nu: Date = new Date()): string {
  const datum = `${twee(nu.getDate())}.${twee(nu.getMonth() + 1)}.${twee(
    nu.getFullYear() % 100,
  )}`;
  const tijd = `${twee(nu.getHours())}.${twee(nu.getMinutes())}`;
  return `[${naam.trim()} ${datum} ${tijd}] `;
}

/**
 * Zet het stempel in de tekst: in een leeg veld vooraan, anders op een
 * nieuwe regel onder de bestaande tekst. Geeft ook de cursorpositie terug
 * (direct achter het stempel).
 */
export function metStempel(
  huidig: string,
  stempel: string,
): { tekst: string; cursor: number } {
  if (huidig.trim() === "") {
    return { tekst: stempel, cursor: stempel.length };
  }
  const tekst = `${huidig.replace(/\s+$/, "")}\n${stempel}`;
  return { tekst, cursor: tekst.length };
}

/** Huidig stempel "[Naam dd.mm.jj uu.mm] ", waar het ook in de regel staat. */
const STEMPEL = /\[[^[\]\n]+ \d{2}\.\d{2}\.\d{2} \d{2}\.\d{2}\] ?/g;

/**
 * Oud stempel "Naam dd.mm.jj uu.mm - " (B9, kort live op 12-10-2026): alleen
 * aan het begin van een regel, en alleen met een naam die met een hoofdletter
 * begint en eindigt. Zo blijft een gewone zin als "Afspraak verzet naar
 * 14.10.26 09.30 - bevestigd" staan.
 */
const OUD_STEMPEL =
  /^[ \t]*[A-ZÀ-ÖØ-Þ][^\s\d[\]]*(?:(?: [^\s\d[\]]+)* [A-ZÀ-ÖØ-Þ][^\s\d[\]]*)? \d{2}\.\d{2}\.\d{2} \d{2}\.\d{2} - ?/;

/**
 * WP3b (fixronde 12-10-2026): de tekst zonder notitiestempels, voor
 * overzichten (tabellen, kaarten, lijsten). Haalt elk stempel weg, nieuw en
 * oud; een regel met alleen een stempel verdwijnt helemaal. De volledige
 * tekst blijft in het bewerkvenster en in de tooltip.
 */
export function verbergNotitiestempels(
  tekst: string | null | undefined,
): string {
  if (!tekst) return "";
  return tekst
    .split("\n")
    .flatMap((regel) => {
      const kaal = regel.replace(OUD_STEMPEL, "").replace(STEMPEL, "");
      return kaal !== regel && kaal.trim() === "" ? [] : [kaal];
    })
    .join("\n")
    .trim();
}
